import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=cddcef5c&scoped=true&"
import script from "./date-input.vue?vue&type=script&lang=js&"
export * from "./date-input.vue?vue&type=script&lang=js&"
import style0 from "./date-input.vue?vue&type=style&index=0&id=cddcef5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddcef5c",
  null
  
)

export default component.exports